// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** {*/
/*    padding: 0;*/
/*    margin: 0;*/
/*    box-sizing: border-box;*/
/*    font-family: "Titillium Web", sans-serif;*/
:root {
    --mainColor: #29335c;
    --mainColorLight: #5767aa;
    --secondaryColor: #db2b39;
    --textColor: #eee;

    --black: #171718;
    --black-border: #26292D;
    --white: #fff;
    --purple: #5C62EC;
    --dark-bg: var(--black);
    --dark-border: var(--black-border);
    --header-text: var(--white);
    --accent: var(--purple)
}

/* Подключение шрифта */

/* Переменные */
:root {
    --header-height: 3rem;
    --footer-height: 4rem;
    --nav-width: 80px;
    --first-color: #4723D9;
    --first-color-light: #AFA5D9;
    --white-color: black;
    --body-font: 'Nunito', sans-serif;
    --normal-font-size: 1rem;
    --color_selected_nav: green;
    --z-fixed: 9999;
}


/* Общее */
a {
    text-decoration: none;
    color: inherit;
    /* это позволяет ссылке использовать цвет, унаследованный от родительского элемента */
}


@keyframes skeleton-animation {
    0% {
        left: -100%;
        /* Начальное положение за пределами кнопки */
    }

    100% {
        left: 100%;
        /* Конечное положение за пределами кнопки */
    }
}

/* Шапка */
.header {
    width: 100%;
    height: var(--header-height);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 1rem;
    background-color: #11172e;
    
    z-index: 9998;
    transition: .5s;
    flex-direction: row;

}
.backgroundMenuClose{
    position: fixed;
    top:0;
    left:0;
    width: 100%;
    height: 100vh;
   
    z-index: 9999;
}
.containerMenu{
    position: absolute;
    
    bottom:100%;
    right: 0;
    transform: translateY(10px);  
    opacity: 0;  
    transition: opacity 0.3s ease, transform 0.3s ease;

}
.containerMenu.active {
    opacity: 1;
    transform: translateY(-15px);
}
.containerMenu.unactive{
    opacity: 0;
    z-index: -1;

}
.footer {
    
    
    width: 95%;
    height: var(--footer-height);
    position: relative;
    
    display: flex;
    align-items: center;
    justify-content: space-between;

    background-color:  #111d2eeb;
    border-radius: 20px;
    
    padding: 5px 20px;
    


}
.wrrapper-footer{
    position: fixed;
    bottom: 10px;
    left: 0;
    z-index: var(--z-fixed);
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    flex-direction: column;
    

}
.header_lang_container {
    position: relative;
    top: 0;
    right: 0;
}

.navbar-brand {
    display: flex;
    gap: 5px;
    align-items: center;
}

.navbar-brand strong {

    font-family: Poppins, sans-serif;
    font-size: 30px;
    font-weight: 700;
    color: white;
}

/* Переключатель шапки */
.header_toggle {
    color: var(--first-color);
    font-size: 10px;
    cursor: pointer;
}

/* Изображение в шапке */
.container_inf_user {


    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

}

.nav-logs {
    font-family: Poppins, sans-serif;
    font-size: 16px;
    font-weight: 500;
    text-decoration: none;
    letter-spacing: 1px;
    outline: none;
}

.container_inf_user a {
    text-decoration: none;
    outline: none;
}

/* Изображение в шапке (изображение) */
.header_img img {
    width: 40px;
}

.navbar-brand i {
    color: greenyellow;
    font-size: 35px;
}

/* Левая навигационная панель */
.l-navbar {
    position: fixed;
    top: 0;
    left: -30%;
    width: var(--nav-width);
    height: 100vh;
    background-color: #191d3e;
    padding: .5rem 1rem 0 0;
    transition: .5s;
    z-index:10001;
    border-bottom-right-radius: 20px;
    border-top-right-radius: 20px;
    border: 1px solid #ffffff2b;
    border-left: 0;
    overflow-y: auto;

    scrollbar-color: #6151ec66 #e0e0e000;

}

/* Навигационное меню */
.nav {
    position: relative;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: hidden;
    justify-content: center;
    z-index: var(--z-fixed);


}

.footer_nav {
    position: absolute;
    bottom: 80px;
    left: 50%;
    transform: translateX(-50%);
    cursor: pointer;
}

.footer_nav img {
    width: 40px;
    height: 40px;

}

/* Логотип в навигационной панели */
.nav_logo,
.nav_link {
    display: grid;
    grid-template-columns: max-content max-content;
    align-items: center;
    column-gap: 1rem;
    padding: .5rem 0 .5rem 1.2rem
}

/* Логотип в навигационной панели (иконка) */
.nav_logo-icon {
    font-size: 1.25rem;
    color: var(--white-color);
}

/* Логотип в навигационной панели (название) */
/*.nav_logo-name {*/
/*    color: var(--white-color);*/
/*    font-weight: 700;*/
/*}*/

/* Ссылка в навигационной панели */
.nav_link {
    position: relative;
    color: var(--first-color-light);
    margin-bottom: 5px;
    transition: .3s;
}


/* Активная ссылка */
.nav_link:hover {
    color: greenyellow;
    text-decoration: none;
}

.nav_link.activeNav i {
    color: greenyellow;
}

/* Активная ссылка (линия) */

.balance_nav {
    color: white !important;
    font-size: 20px;
    font-family: "Tahoma", sans-serif;
    position: relative;
}

.login_nav {
    font-family: Poppins, sans-serif;
    font-size: 20px;
    color: #97ffc2 !important;
    ;
}

a:focus,
a:active {
    outline: none;
    /* Убирает обводку при фокусе или активации */
}

.wallet_nav_bar {
    display: flex;
    align-items: center;
    padding: 0.5rem 1rem;
    background-color: #4caf50;
    border-radius: 0.5rem;
    color: white;
    letter-spacing: 1px;
    font-family: Poppins, sans-serif;
    font-weight: 400;
    gap: 6px;
    justify-content: center;



}

/* Полная высота */
.height-100 {
    height: 100vh;
}

.show {
    left: 0;
}

/* Отступ слева для контента */
.body-pd {
    padding-left: calc(var(--nav-width) + 1rem);
}

.nav_icon {
    color: var(--first-color-light);
    font-size: 22px;
}

.toggler-icon {
    position: fixed;
    cursor: pointer;

    top: 10px;
    left: 20px;
    z-index: 10000000;
    font-size: 40px;
    color: greenyellow;

}

.nav_name {
    font-family: 'Poppins', sans-serif;
    font-weight: 500;

}

.show {
    width: calc(var(--nav-width) + 180px);
}

.body-pd {
    padding-left: calc(var(--nav-width) + 188px);
}

/* Медиа-запросы */
@media screen and (min-width: 1000px) {


    body {
        margin: calc(var(--header-height) + 1rem) 0 0 0;
    }


    .header {
        height: calc(var(--header-height) + 1rem);
        padding: 0 10px 0 calc(var(--nav-width) + 10px);
        flex-direction: row;
    }

    .header_img {
        width: 40px;
        height: 40px;
    }

    .header_img img {
        width: 45px;
    }

    .l-navbar {
        left: 0;
        padding: 1rem 1rem 0 0;
    }



}

.navbar-brand.unreg strong {
    font-size: 15px;

}

.navbar-brand.unreg i {
    font-size: 20px;

}

@media screen and (max-width: 1000px) {
    .fa-wallet {

        cursor: pointer;

        font-size: 25px;
    }

    .container_inf_user {
        gap: 5px;
    }

    .fa-right-to-bracket {
        font-size: 10px;
    }

    .navbar-brand {
        padding: 0 !important;
        margin: 0 !important;
        ;
        gap: 0;
    }

    .nav-logs,
    nav-logs i {
        font-size: 11px;
        letter-spacing: 0;
    }

    .nav {
        justify-content: center;
    }

    .wallet_nav_bar.pink {
        font-size: 25px;
    }

   
    .wallet_nav_bar.phone{
        border-radius: 0;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    .wallet_nav_bar{
        
    }
    .balance_nav {
        font-size: 15px;
    }

    .header {

        height: 60px;
        padding-left: 10px;
        padding-right: 10px;

    }

    .toggler-icon_phone {
        cursor: pointer;

        z-index: 1000;
        font-size: 30px;
        color: greenyellow;
    }


}

.container_toggler_nav {
    position: relative;
    top: 0;
    left: 20px;
    margin-bottom: 10px;
}

.container_toggler_nav.open {
    left: 0;
    right: 20px;

}

.wallet_nav_bar.pink {
    background-color: #710cff;

}

.skeleton-button {
    position: relative;
    overflow: hidden;
}

.skeleton-button::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    /* Начальное положение за пределами кнопки */
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    animation: skeleton-animation 2.5s infinite;
    z-index: 2;
}

@keyframes skeleton-animation {
    0% {
        left: -100%;
        /* Начальное положение за пределами кнопки */
    }

    100% {
        left: 100%;
        /* Конечное положение за пределами кнопки */
    }
}

.wallet_nav_bar:hover {
    color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA,MAAM;AACN,kBAAkB;AAClB,iBAAiB;AACjB,8BAA8B;AAC9B,gDAAgD;AAChD;IACI,oBAAoB;IACpB,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;;IAEjB,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,uBAAuB;IACvB,kCAAkC;IAClC,2BAA2B;IAC3B;AACJ;;AAEA,uBAAuB;;AAGvB,eAAe;AACf;IACI,qBAAqB;IACrB,qBAAqB;IACrB,iBAAiB;IACjB,sBAAsB;IACtB,4BAA4B;IAC5B,oBAAoB;IACpB,iCAAiC;IACjC,wBAAwB;IACxB,2BAA2B;IAC3B,eAAe;AACnB;;;AAGA,UAAU;AACV;IACI,qBAAqB;IACrB,cAAc;IACd,qFAAqF;AACzF;;;AAGA;IACI;QACI,WAAW;QACX,4CAA4C;IAChD;;IAEA;QACI,UAAU;QACV,2CAA2C;IAC/C;AACJ;;AAEA,UAAU;AACV;IACI,WAAW;IACX,4BAA4B;IAC5B,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;;IAEzB,aAAa;IACb,eAAe;IACf,mBAAmB;;AAEvB;AACA;IACI,eAAe;IACf,KAAK;IACL,MAAM;IACN,WAAW;IACX,aAAa;;IAEb,aAAa;AACjB;AACA;IACI,kBAAkB;;IAElB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,kDAAkD;;AAEtD;AACA;IACI,UAAU;IACV,4BAA4B;AAChC;AACA;IACI,UAAU;IACV,WAAW;;AAEf;AACA;;;IAGI,UAAU;IACV,4BAA4B;IAC5B,kBAAkB;;IAElB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,4BAA4B;IAC5B,mBAAmB;;IAEnB,iBAAiB;;;;AAIrB;AACA;IACI,eAAe;IACf,YAAY;IACZ,OAAO;IACP,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,sBAAsB;;;AAG1B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;;IAEI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA,wBAAwB;AACxB;IACI,yBAAyB;IACzB,eAAe;IACf,eAAe;AACnB;;AAEA,wBAAwB;AACxB;;;IAGI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;;AAEZ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;AACjB;;AAEA,sCAAsC;AACtC;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,eAAe;IACf,MAAM;IACN,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,gCAAgC;IAChC,6BAA6B;IAC7B,2BAA2B;IAC3B,cAAc;IACd,gBAAgB;;IAEhB,oCAAoC;;AAExC;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;;;AAG3B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA,mCAAmC;AACnC;;IAEI,aAAa;IACb,8CAA8C;IAC9C,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA,8CAA8C;AAC9C,mBAAmB;AACnB,iCAAiC;AACjC,wBAAwB;AACxB,IAAI;;AAEJ,kCAAkC;AAClC;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,eAAe;AACnB;;;AAGA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,4BAA4B;;AAE5B;IACI,uBAAuB;IACvB,eAAe;IACf,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,yBAAyB;;AAE7B;;AAEA;;IAEI,aAAa;IACb,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,gBAAgB;IAChB,QAAQ;IACR,uBAAuB;;;;AAI3B;;AAEA,kBAAkB;AAClB;IACI,aAAa;AACjB;;AAEA;IACI,OAAO;AACX;;AAEA,8BAA8B;AAC9B;IACI,2CAA2C;AAC/C;;AAEA;IACI,+BAA+B;IAC/B,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;;IAEf,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,kBAAkB;;AAEtB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;;AAEpB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,4CAA4C;AAChD;;AAEA,kBAAkB;AAClB;;;IAGI;QACI,+CAA+C;IACnD;;;IAGA;QACI,yCAAyC;QACzC,+CAA+C;QAC/C,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,OAAO;QACP,sBAAsB;IAC1B;;;;AAIJ;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI;;QAEI,eAAe;;QAEf,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qBAAqB;QACrB,oBAAoB;;QAEpB,MAAM;IACV;;IAEA;;QAEI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,gBAAgB;QAChB,6BAA6B;QAC7B,gCAAgC;IACpC;IACA;;IAEA;IACA;QACI,eAAe;IACnB;;IAEA;;QAEI,YAAY;QACZ,kBAAkB;QAClB,mBAAmB;;IAEvB;;IAEA;QACI,eAAe;;QAEf,aAAa;QACb,eAAe;QACf,kBAAkB;IACtB;;;AAGJ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,WAAW;;AAEf;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,4CAA4C;IAC5C,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,2CAA2C;IAC3C,UAAU;AACd;;AAEA;IACI;QACI,WAAW;QACX,4CAA4C;IAChD;;IAEA;QACI,UAAU;QACV,2CAA2C;IAC/C;AACJ;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":["/** {*/\r\n/*    padding: 0;*/\r\n/*    margin: 0;*/\r\n/*    box-sizing: border-box;*/\r\n/*    font-family: \"Titillium Web\", sans-serif;*/\r\n:root {\r\n    --mainColor: #29335c;\r\n    --mainColorLight: #5767aa;\r\n    --secondaryColor: #db2b39;\r\n    --textColor: #eee;\r\n\r\n    --black: #171718;\r\n    --black-border: #26292D;\r\n    --white: #fff;\r\n    --purple: #5C62EC;\r\n    --dark-bg: var(--black);\r\n    --dark-border: var(--black-border);\r\n    --header-text: var(--white);\r\n    --accent: var(--purple)\r\n}\r\n\r\n/* Подключение шрифта */\r\n@import url(\"https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700&display=swap\");\r\n\r\n/* Переменные */\r\n:root {\r\n    --header-height: 3rem;\r\n    --footer-height: 4rem;\r\n    --nav-width: 80px;\r\n    --first-color: #4723D9;\r\n    --first-color-light: #AFA5D9;\r\n    --white-color: black;\r\n    --body-font: 'Nunito', sans-serif;\r\n    --normal-font-size: 1rem;\r\n    --color_selected_nav: green;\r\n    --z-fixed: 9999;\r\n}\r\n\r\n\r\n/* Общее */\r\na {\r\n    text-decoration: none;\r\n    color: inherit;\r\n    /* это позволяет ссылке использовать цвет, унаследованный от родительского элемента */\r\n}\r\n\r\n\r\n@keyframes skeleton-animation {\r\n    0% {\r\n        left: -100%;\r\n        /* Начальное положение за пределами кнопки */\r\n    }\r\n\r\n    100% {\r\n        left: 100%;\r\n        /* Конечное положение за пределами кнопки */\r\n    }\r\n}\r\n\r\n/* Шапка */\r\n.header {\r\n    width: 100%;\r\n    height: var(--header-height);\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 1rem;\r\n    background-color: #11172e;\r\n    \r\n    z-index: 9998;\r\n    transition: .5s;\r\n    flex-direction: row;\r\n\r\n}\r\n.backgroundMenuClose{\r\n    position: fixed;\r\n    top:0;\r\n    left:0;\r\n    width: 100%;\r\n    height: 100vh;\r\n   \r\n    z-index: 9999;\r\n}\r\n.containerMenu{\r\n    position: absolute;\r\n    \r\n    bottom:100%;\r\n    right: 0;\r\n    transform: translateY(10px);  \r\n    opacity: 0;  \r\n    transition: opacity 0.3s ease, transform 0.3s ease;\r\n\r\n}\r\n.containerMenu.active {\r\n    opacity: 1;\r\n    transform: translateY(-15px);\r\n}\r\n.containerMenu.unactive{\r\n    opacity: 0;\r\n    z-index: -1;\r\n\r\n}\r\n.footer {\r\n    \r\n    \r\n    width: 95%;\r\n    height: var(--footer-height);\r\n    position: relative;\r\n    \r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n\r\n    background-color:  #111d2eeb;\r\n    border-radius: 20px;\r\n    \r\n    padding: 5px 20px;\r\n    \r\n\r\n\r\n}\r\n.wrrapper-footer{\r\n    position: fixed;\r\n    bottom: 10px;\r\n    left: 0;\r\n    z-index: var(--z-fixed);\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    flex-direction: column;\r\n    \r\n\r\n}\r\n.header_lang_container {\r\n    position: relative;\r\n    top: 0;\r\n    right: 0;\r\n}\r\n\r\n.navbar-brand {\r\n    display: flex;\r\n    gap: 5px;\r\n    align-items: center;\r\n}\r\n\r\n.navbar-brand strong {\r\n\r\n    font-family: Poppins, sans-serif;\r\n    font-size: 30px;\r\n    font-weight: 700;\r\n    color: white;\r\n}\r\n\r\n/* Переключатель шапки */\r\n.header_toggle {\r\n    color: var(--first-color);\r\n    font-size: 10px;\r\n    cursor: pointer;\r\n}\r\n\r\n/* Изображение в шапке */\r\n.container_inf_user {\r\n\r\n\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 8px;\r\n\r\n}\r\n\r\n.nav-logs {\r\n    font-family: Poppins, sans-serif;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    text-decoration: none;\r\n    letter-spacing: 1px;\r\n    outline: none;\r\n}\r\n\r\n.container_inf_user a {\r\n    text-decoration: none;\r\n    outline: none;\r\n}\r\n\r\n/* Изображение в шапке (изображение) */\r\n.header_img img {\r\n    width: 40px;\r\n}\r\n\r\n.navbar-brand i {\r\n    color: greenyellow;\r\n    font-size: 35px;\r\n}\r\n\r\n/* Левая навигационная панель */\r\n.l-navbar {\r\n    position: fixed;\r\n    top: 0;\r\n    left: -30%;\r\n    width: var(--nav-width);\r\n    height: 100vh;\r\n    background-color: #191d3e;\r\n    padding: .5rem 1rem 0 0;\r\n    transition: .5s;\r\n    z-index:10001;\r\n    border-bottom-right-radius: 20px;\r\n    border-top-right-radius: 20px;\r\n    border: 1px solid #ffffff2b;\r\n    border-left: 0;\r\n    overflow-y: auto;\r\n\r\n    scrollbar-color: #6151ec66 #e0e0e000;\r\n\r\n}\r\n\r\n/* Навигационное меню */\r\n.nav {\r\n    position: relative;\r\n    height: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    overflow: hidden;\r\n    justify-content: center;\r\n    z-index: var(--z-fixed);\r\n\r\n\r\n}\r\n\r\n.footer_nav {\r\n    position: absolute;\r\n    bottom: 80px;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    cursor: pointer;\r\n}\r\n\r\n.footer_nav img {\r\n    width: 40px;\r\n    height: 40px;\r\n\r\n}\r\n\r\n/* Логотип в навигационной панели */\r\n.nav_logo,\r\n.nav_link {\r\n    display: grid;\r\n    grid-template-columns: max-content max-content;\r\n    align-items: center;\r\n    column-gap: 1rem;\r\n    padding: .5rem 0 .5rem 1.2rem\r\n}\r\n\r\n/* Логотип в навигационной панели (иконка) */\r\n.nav_logo-icon {\r\n    font-size: 1.25rem;\r\n    color: var(--white-color);\r\n}\r\n\r\n/* Логотип в навигационной панели (название) */\r\n/*.nav_logo-name {*/\r\n/*    color: var(--white-color);*/\r\n/*    font-weight: 700;*/\r\n/*}*/\r\n\r\n/* Ссылка в навигационной панели */\r\n.nav_link {\r\n    position: relative;\r\n    color: var(--first-color-light);\r\n    margin-bottom: 5px;\r\n    transition: .3s;\r\n}\r\n\r\n\r\n/* Активная ссылка */\r\n.nav_link:hover {\r\n    color: greenyellow;\r\n    text-decoration: none;\r\n}\r\n\r\n.nav_link.activeNav i {\r\n    color: greenyellow;\r\n}\r\n\r\n/* Активная ссылка (линия) */\r\n\r\n.balance_nav {\r\n    color: white !important;\r\n    font-size: 20px;\r\n    font-family: \"Tahoma\", sans-serif;\r\n    position: relative;\r\n}\r\n\r\n.login_nav {\r\n    font-family: Poppins, sans-serif;\r\n    font-size: 20px;\r\n    color: #97ffc2 !important;\r\n    ;\r\n}\r\n\r\na:focus,\r\na:active {\r\n    outline: none;\r\n    /* Убирает обводку при фокусе или активации */\r\n}\r\n\r\n.wallet_nav_bar {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0.5rem 1rem;\r\n    background-color: #4caf50;\r\n    border-radius: 0.5rem;\r\n    color: white;\r\n    letter-spacing: 1px;\r\n    font-family: Poppins, sans-serif;\r\n    font-weight: 400;\r\n    gap: 6px;\r\n    justify-content: center;\r\n\r\n\r\n\r\n}\r\n\r\n/* Полная высота */\r\n.height-100 {\r\n    height: 100vh;\r\n}\r\n\r\n.show {\r\n    left: 0;\r\n}\r\n\r\n/* Отступ слева для контента */\r\n.body-pd {\r\n    padding-left: calc(var(--nav-width) + 1rem);\r\n}\r\n\r\n.nav_icon {\r\n    color: var(--first-color-light);\r\n    font-size: 22px;\r\n}\r\n\r\n.toggler-icon {\r\n    position: fixed;\r\n    cursor: pointer;\r\n\r\n    top: 10px;\r\n    left: 20px;\r\n    z-index: 10000000;\r\n    font-size: 40px;\r\n    color: greenyellow;\r\n\r\n}\r\n\r\n.nav_name {\r\n    font-family: 'Poppins', sans-serif;\r\n    font-weight: 500;\r\n\r\n}\r\n\r\n.show {\r\n    width: calc(var(--nav-width) + 180px);\r\n}\r\n\r\n.body-pd {\r\n    padding-left: calc(var(--nav-width) + 188px);\r\n}\r\n\r\n/* Медиа-запросы */\r\n@media screen and (min-width: 1000px) {\r\n\r\n\r\n    body {\r\n        margin: calc(var(--header-height) + 1rem) 0 0 0;\r\n    }\r\n\r\n\r\n    .header {\r\n        height: calc(var(--header-height) + 1rem);\r\n        padding: 0 10px 0 calc(var(--nav-width) + 10px);\r\n        flex-direction: row;\r\n    }\r\n\r\n    .header_img {\r\n        width: 40px;\r\n        height: 40px;\r\n    }\r\n\r\n    .header_img img {\r\n        width: 45px;\r\n    }\r\n\r\n    .l-navbar {\r\n        left: 0;\r\n        padding: 1rem 1rem 0 0;\r\n    }\r\n\r\n\r\n\r\n}\r\n\r\n.navbar-brand.unreg strong {\r\n    font-size: 15px;\r\n\r\n}\r\n\r\n.navbar-brand.unreg i {\r\n    font-size: 20px;\r\n\r\n}\r\n\r\n@media screen and (max-width: 1000px) {\r\n    .fa-wallet {\r\n\r\n        cursor: pointer;\r\n\r\n        font-size: 25px;\r\n    }\r\n\r\n    .container_inf_user {\r\n        gap: 5px;\r\n    }\r\n\r\n    .fa-right-to-bracket {\r\n        font-size: 10px;\r\n    }\r\n\r\n    .navbar-brand {\r\n        padding: 0 !important;\r\n        margin: 0 !important;\r\n        ;\r\n        gap: 0;\r\n    }\r\n\r\n    .nav-logs,\r\n    nav-logs i {\r\n        font-size: 11px;\r\n        letter-spacing: 0;\r\n    }\r\n\r\n    .nav {\r\n        justify-content: center;\r\n    }\r\n\r\n    .wallet_nav_bar.pink {\r\n        font-size: 25px;\r\n    }\r\n\r\n   \r\n    .wallet_nav_bar.phone{\r\n        border-radius: 0;\r\n        border-top-right-radius: 10px;\r\n        border-bottom-right-radius: 10px;\r\n    }\r\n    .wallet_nav_bar{\r\n        \r\n    }\r\n    .balance_nav {\r\n        font-size: 15px;\r\n    }\r\n\r\n    .header {\r\n\r\n        height: 60px;\r\n        padding-left: 10px;\r\n        padding-right: 10px;\r\n\r\n    }\r\n\r\n    .toggler-icon_phone {\r\n        cursor: pointer;\r\n\r\n        z-index: 1000;\r\n        font-size: 30px;\r\n        color: greenyellow;\r\n    }\r\n\r\n\r\n}\r\n\r\n.container_toggler_nav {\r\n    position: relative;\r\n    top: 0;\r\n    left: 20px;\r\n    margin-bottom: 10px;\r\n}\r\n\r\n.container_toggler_nav.open {\r\n    left: 0;\r\n    right: 20px;\r\n\r\n}\r\n\r\n.wallet_nav_bar.pink {\r\n    background-color: #710cff;\r\n\r\n}\r\n\r\n.skeleton-button {\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.skeleton-button::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    /* Начальное положение за пределами кнопки */\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\r\n    animation: skeleton-animation 2.5s infinite;\r\n    z-index: 2;\r\n}\r\n\r\n@keyframes skeleton-animation {\r\n    0% {\r\n        left: -100%;\r\n        /* Начальное положение за пределами кнопки */\r\n    }\r\n\r\n    100% {\r\n        left: 100%;\r\n        /* Конечное положение за пределами кнопки */\r\n    }\r\n}\r\n\r\n.wallet_nav_bar:hover {\r\n    color: white !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
